export default "__VITE_ASSET__DicSJ2Mx__"